﻿import React, { useEffect } from 'react';

import { GMetrixLoader } from 'components/GMetrixLoader/GMetrixLoader';
import { Resource, ResourceType } from 'types';
import { FormattedMessage } from 'react-intl';
import { useSuperState } from 'hooks';

import 'pages/courses/resources/components/Stage/styles/stage.scss';

interface StageProps {
	resource?: Resource;
}

const Stage: React.FC<StageProps> = ({ resource }) => {

    const [state, setState] = useSuperState({
        loading: false
    });
    const { loading } = state;

    const handleLoaded = () => setState({ loading: false });

    const getStageInner = () => {

        switch (resource?.TypeId){

            case ResourceType.Pdf:
            case ResourceType.WebContent:
                return (
                    <iframe
                        className={`d-${loading ? 'none' : 'block'}`}
                        height="100%"
                        onLoad={handleLoaded}
                        src={resource.Url}
                        width="100%"
                    />
                );
            case ResourceType.WordDocument:
            case ResourceType.PowerpointDocument:
            case ResourceType.ExcelDocument:
            case ResourceType.ZipFile:
                return (
                    <div className="d-flex align-items-center p-5">
                        <FormattedMessage defaultMessage="Click To Download" id="click_to_download.daa78d65" />
                        <a download className="ms-3 stage-button" href={resource.Url}>
                            <FormattedMessage defaultMessage="Download" id="download.5e1e7483" />
                            <i className="stage-icon fa-solid fa-download"/>
                        </a>
                    </div>
                );
            default:
                return (
                    <div>
                        <FormattedMessage defaultMessage="Select a resource to preview" id="select_a_resource_to_preview.ef925261" />
                    </div>
                );

        }

    };

    useEffect(() => {

        // If this resource doesn't require time to load, leave loading state off
        if (![ResourceType.Pdf, ResourceType.WebContent].includes(resource?.TypeId)) return;

        // Show the loading state while iframe content loads
        setState({ loading: true });

    }, [resource?.TypeId]);

    return (
        <div className="stage h-100 mobile-preview">
            <div className="stage-content card card-body">
                <div className="stage-title border-bottom w-100 mb-3 pb-3">
                    <h3 className="stage-breadcrumbs">
                        {resource?.Name ?? <FormattedMessage defaultMessage="Preview" id="preview.9fa9aebd" />}
                    </h3>
                </div>

                {loading && (
                    <div className={'d-flex align-items-center justify-content-center p-5'}>
                        <GMetrixLoader size={'large'} />
                    </div>
                )}

                {getStageInner()}

            </div>
        </div>
    );

};

export { Stage };